import React from 'react';
import SubcriptionOfferTime from '../Backend/SubcriptionOfferTime';
import OfferCountdown from '../Payment/OfferCountdown';
import './Style/OfferTime.css';
import { Link } from 'react-router-dom';


function OfferTime() {
    const { subcriptionOffer, subcriptionOfferLoading } = SubcriptionOfferTime();

    const allOfferTime = subcriptionOffer?.find(offer => offer.id === 1);
    const expiryTime = allOfferTime?.time;

    // Check if expiryTime is available and valid
    const isExpired = expiryTime ? new Date(expiryTime).getTime() <= Date.now() : true;

    // Return null if data is loading, missing, or if the offer has expired
    if (subcriptionOfferLoading || !expiryTime || isExpired) {
        return null;
    }

    return (
        <div className="offer-time-banner">
            <div className="offer-badge">LIMITED TIME OFFER</div>

            <div className="offer-header">
                <span className="offer-icon">⚡</span>
                <span className="offer-title">Special Discount Ending Soon!</span>
            </div>

            <div className="offer-countdown-wrapper">
                <OfferCountdown targetDate={expiryTime} />
            </div>

            <Link to="/product-list" className="offer-cta-btn" >
                <span>Subscribe & Unlock All</span>
                <span className="offer-price-tag">₹ 100</span>
            </Link>
        </div>
    );
}

export default OfferTime;